import React from 'react';
import PropTypes from 'prop-types';

import SchoolYearSelect from 'components/SchoolYearSelect';
import './styles/MyReviewsHeader.scss';

const MyReviewsHeader = ({
  onSchoolYearChange,
  schoolYears,
  schoolYearId
}) => {
  const isArchived = year => year.archived
  const isSelected = year => year.id == schoolYearId
  const dropdownSchoolYears = schoolYears.filter(year => !isArchived(year) || isSelected(year))
  return (
    <div className='review-contact-list-header title-row'>
      <h2 className='review-contact-list-header__title'>
        Admissions Reviews
        {schoolYears.find(year => year.review_enabled) ? (
          <SchoolYearSelect
            onSelect={onSchoolYearChange}
            schoolYears={dropdownSchoolYears}
            schoolYearId={schoolYearId}
          />
        ) : <div>There are no review years enabled</div>}
      </h2>
    </div>
  )
};

MyReviewsHeader.propTypes = {
  /** Currently School Year ID */
  schoolYearId: PropTypes.string,

  /** Array of School Year objects */
  schoolYears: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      review_enabled: PropTypes.bool
    })
  ),

  /** onSchoolYearChange callback */
  onSchoolYearChange: PropTypes.func
};

MyReviewsHeader.defaultProps = {
  schoolYearId: '',
  schoolYears: [],
  onSchoolYearChange: () => false
};

export default MyReviewsHeader;
